// @flow
export { default } from './FakeBrandCard';



// WEBPACK FOOTER //
// ./src/components/common/FakeBrandCard/index.js